export const sv = {
  loading: 'Hämtar verkstaden…',

  // OTP step
  heading: 'Hämta din verkstad',
  intro: 'Vi har skickat en kod till {email}. Ange den för att ta över {garage}.',
  openRequests: {
    zero: 'Inga öppna förfrågningar i ert område just nu — nya dyker upp löpande.',
    one: '1 förfrågan väntar på offert i ert område.',
    other: '{count} förfrågningar väntar på offert i ert område.',
  },
  codeLabel: 'Kod från mejlet',
  submit: 'Hämta verkstaden',
  errWrongCode: 'Koden stämmer inte eller har gått ut.',
  errGeneric: 'Något gick fel. Försök igen.',

  // Expired link — self-healing, not a dead end
  expiredHeading: 'Länken har gått ut',
  expiredBody: 'Ingen fara. Vi skickar en ny länk till adressen vi har för verkstaden.',
  resend: 'Skicka en ny länk',
  resentHeading: 'En ny länk är på väg',
  resentBody: 'Kolla inkorgen för {email}. Länken gäller i 30 dagar.',

  // Terminal states
  invalidHeading: 'Länken fungerar inte',
  invalidBody: 'Den här länken är ogiltig. Hör av dig till oss så hjälper vi till.',
  claimedHeading: 'Verkstaden är redan registrerad',
  claimedBody: 'Någon har redan hämtat den här verkstaden. Logga in i stället.',
  goToLogin: 'Gå till inloggning',

  // Optional phone step after the claim
  phoneHeading: 'Vill du kunna logga in med SMS?',
  phoneBody: 'Lägg till ett mobilnummer så kan du logga in med en kod via SMS. Du kan hoppa över det här och göra det senare.',
  phoneLabel: 'Mobilnummer',
  phoneSend: 'Skicka kod',
  phoneCodeLabel: 'Kod från SMS',
  phoneVerify: 'Verifiera',
  phoneSkip: 'Hoppa över',
  phoneErr: 'Numret kunde inte verifieras. Försök igen eller hoppa över.',
}

export const en: typeof sv = {
  loading: 'Loading the garage…',

  heading: 'Claim your garage',
  intro: 'We sent a code to {email}. Enter it to claim {garage}.',
  openRequests: {
    zero: 'No open requests in your area right now — new ones come in all the time.',
    one: '1 request is waiting for a quote in your area.',
    other: '{count} requests are waiting for a quote in your area.',
  },
  codeLabel: 'Code from the email',
  submit: 'Claim the garage',
  errWrongCode: 'That code is wrong or has expired.',
  errGeneric: 'Something went wrong. Please try again.',

  expiredHeading: 'This link has expired',
  expiredBody: 'No problem. We will send a fresh one to the address we have for the garage.',
  resend: 'Send a new link',
  resentHeading: 'A new link is on its way',
  resentBody: 'Check the inbox for {email}. The link is valid for 30 days.',

  invalidHeading: 'This link does not work',
  invalidBody: 'The link is not valid. Get in touch and we will sort it out.',
  claimedHeading: 'This garage is already registered',
  claimedBody: 'Someone has already claimed it. Log in instead.',
  goToLogin: 'Go to login',

  phoneHeading: 'Want to log in with SMS?',
  phoneBody: 'Add a mobile number to log in with a code by SMS. You can skip this and do it later.',
  phoneLabel: 'Mobile number',
  phoneSend: 'Send code',
  phoneCodeLabel: 'Code from SMS',
  phoneVerify: 'Verify',
  phoneSkip: 'Skip',
  phoneErr: 'We could not verify that number. Try again or skip.',
}
